import { FC } from "react";
import { SchemaItemProps } from "@data-root/react";
import { RefRowsSchemaItem } from "@data-root/types";
import { DeckPresentation } from "./DeckPresentation";
import { FeedPresentation } from "./FeedPresentation";

export const RefRowsInput: FC<SchemaItemProps<RefRowsSchemaItem>> = ({
  item,
}) => {
  switch (item.presentation) {
    case "Feed":
      return <FeedPresentation item={item} />;
    case "Deck":
    default:
      return <DeckPresentation item={item} />;
  }
};
